import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import {useIntl} from 'react-intl'

interface DeleteModalProps {
  isOpen: boolean
  onRequestClose: () => void
  onDelete: () => void
  isDeleting: boolean
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onRequestClose,
  onDelete,
  isDeleting,
}) => {
  const {formatMessage} = useIntl()
  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage({id: 'Confirm Delete'})}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{formatMessage({id: 'Are you sure you want to delete this contact?'})}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onRequestClose} disabled={isDeleting}>
          {formatMessage({id: 'Cancel'})}
        </Button>
        <Button variant='danger' onClick={onDelete} disabled={isDeleting}>
          {isDeleting ? formatMessage({id: 'Deleting...'}) : formatMessage({id: 'Delete'})}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteModal
